<template>
  <page title="Email">
    <div class="box">
      <b-table
        class="is-middle"
        :data="addresses.data"
        :loading="addresses.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :total="addresses.total"
        :per-page="addresses.per_page"
        @page-change="
          page => {
            addresses.changePage(page);
          }
        "
      >
        <template slot-scope="props">
          <b-table-column label="#" field="id">{{ props.row.id }}</b-table-column>

          <b-table-column label="Email" field="email">{{ props.row.email }}</b-table-column>

          <b-table-column label="State" field="status">
            <span
              class="tag"
              :class="{ 'is-warning': props.row.status !== 'delivered' }"
            >{{ props.row.status }}</span>
          </b-table-column>

          <b-table-column label="Description" field="description">{{ props.row.description }}</b-table-column>

          <b-table-column label="Нийт илгээсэн" field="sends_count">{{ props.row.sends_count }}</b-table-column>

          <b-table-column label="Үйлчилгээ" field="provider" centered>{{ props.row.provider }}</b-table-column>

          <b-table-column label="Сүүлд илгээсэн" field="updated_at">{{ props.row.updated_at }}</b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>No result.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      addresses: new window.PaginatedRemoteCollection(
        "/admin/api/email-addresses"
      ).load()
    };
  }
};
</script>
